import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ILocale, LOCALE } from "libraries/module/formbuilder/fields/date/config/locale";
import { DateParserService } from 'libraries/service/date/dateParser.service';
import { IDateParserOptions } from 'libraries/service/date/IDateParserOptions';
import { FormBuilderService } from "libraries/service/formBuilder/formBuilder.service";
import { LanguageService } from "libraries/service/language/language.service";
import _get from 'lodash-es/get';
import _isString from 'lodash-es/isString';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { GenericField, IGenericField } from '../generic-field';




/**
 * Date-field
 * Generate date field with calendar
 * @deprecated
 */
@Component({
    selector: 'date-field',
    templateUrl: './date-field.component.html',
})
export class DateFieldComponent extends GenericField implements IGenericField, OnInit, OnChanges, OnDestroy {
    @Input()
    public useInternValid: boolean = false;

    public subscription: Subscription;

    public focusEmit: EventEmitter<boolean> = new EventEmitter();

    public reset: any[] = [{}];

    public readonly wording: ILocale = LOCALE;

    public en: any = {
        closeText: "Close",
        prevText: "Previous",
        nextText: "Next",
        currentText: "Today",
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        weekHeader: "Week",
        dateFormat: "mm/dd/yyyy",
        momentDateFormat: "mm/dd/yyyy",
        firstDayOfWeek: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    };

    constructor(
        public formBuilderService: FormBuilderService,
        private readonly dateParser: DateParserService,
        public readonly languageService: LanguageService,
    ) {
        super();
    }

    /**
     * Convert Date 25Oct to 25/10/20**
     */
    public convertDate(event: any): void {
        const field = this.group.get(this.controlName);
        const value: string = event.target.value || event.srcElement.value;

        if (field.errors && field.errors.invalidDate && value) {
            const options: IDateParserOptions = {
                min: this.minDate,
                max: this.maxDate,
            };

            if (this.past) {
                options.max = options.max || new Date();
                options.yearsIncrement = 100;
            }

            const parsed = this.dateParser.parse(value, options);
            if (parsed) {
                field.patchValue(parsed);

                field.setErrors(null);
            }
        }
    }

    public ngOnInit(): void {
        const val = this.group.get(this.controlName).value;

        this.group.get(this.controlName).patchValue(val);
        this.subscription = this.formBuilderService
            .focusEvent
            .subscribe(
                (_focusName: any) => {
                    if (this.focusName && _focusName === this.focusName) {
                        this.focusEmit.emit(true);
                    }
                });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.onRecreate();

        const originalNewMinDate = _get(changes, ['minDate', 'currentValue']);
        const originalInputDate = this.group.get(this.controlName).value;

        let newMinDate: moment.Moment;
        let inputDate: moment.Moment;

        if (originalNewMinDate && originalInputDate !== "" && this.useInternValid) {
            if (_isString(originalInputDate)) {
                inputDate = moment(originalInputDate,
                    this.wording[this.languageService.simpleUserLanguage]
                        ? this.wording[this.languageService.simpleUserLanguage].momentDateFormat
                        : "DD/MM/YYYY");
            } else {
                inputDate = moment(originalInputDate);
            }
            newMinDate = moment(originalNewMinDate);
            if (newMinDate.isAfter(inputDate, 'day')) {
                this.group.setErrors({
                    "isBeforeMin": true,
                });
            } else {
                this.group.setErrors({
                    "isBeforeMin": null,
                });
                // If not running this function, the control appears to be invalid
                // because its error is an object
                this.group.updateValueAndValidity();
            }
        }

    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }


    /**
     * onREcreate
     *
     * some value are set on ngOnInit in calendar.
     * this methode reSet the calendar
     */
    public onRecreate(): void {
        this.reset[0] = {};
    }

    public getErrors(): ValidationErrors {
        const errors: ValidationErrors | null = this.group.get(this.controlName).errors;
        return errors ? errors : {};
    }

}
